
document.addEventListener( 'click', ( ev ) => {
    // add to basket button.
    if ( ev.target.closest( '.button_tocart' ) ) {
        const formEl = ev.target.closest( '#articletobasketform' ) || null;
        return addItemTobasket( formEl && new FormData( formEl ) );
    }

    // fallback for new engarde button classes
    if ( ev.target.closest( '.article_submit_wrapper .en_mdl_article_detail__button' ) ) {
        if ( ! ev.target.classList.contains( 'en_js_open_popup' ) ) {
            return addItemTobasket();
        }
    }
})

function initializeAddToBasket() {

    document.querySelectorAll( '.popup_add_to_basket_button' ).forEach( buttonEl => {
        buttonEl.addEventListener( 'click', ( ev ) => {
            if ( buttonEl.classList.contains( 'en_button--loading' ) ) {
                ev.preventDefault();
                return;
            }

            buttonEl.classList.add( 'en_button--loading' );

            const size = buttonEl.getAttribute( 'data-variant-id' );
            const oxid = buttonEl.getAttribute( 'data-oxid' );
            const type = buttonEl.getAttribute( 'data-type' );

            // Prepare formdata.
            const dataParams = new FormData( document.getElementById( 'articletobasketform' ) );
            dataParams.set( 'varselid[1]', size );
            dataParams.set( 'anid', oxid );
            dataParams.set( 'aid', oxid );
            dataParams.set( 'type', type );

            // Add to Basket.
            return addItemTobasket(dataParams).then( function( response ) {
                if ( response ) {
                    EN_KO.functions.close_popup();
                    window.scrollTo( 0, 0 );
                }
            }).finally( function() {
                buttonEl.classList.remove( 'en_button--loading' );
            })
        });
    });
}

function addItemTobasket( params = null ) {

    // Get Parameters.
    const dataParams = new URLSearchParams( params || new FormData( document.getElementById( 'articletobasketform' ) ) );
    const productArticleId = dataParams.get( 'aid' );
    const marketArticleId = dataParams.get( 'marketartikelid' );

    // Add class loading
    const successIndicatorEls = Array.from( document.querySelectorAll( '.success_indicator' ) );
    successIndicatorEls.forEach( buttonEl => buttonEl.classList.add( 'en_button--loading' ) );
    window.isArticleAdded = true;

    // Use new AddToBasket from class.
    return AclMiniBasket.submitForm( dataParams )
        .then( async ( response ) => {

            $( document ).trigger( 'added_to_cart.sl', [marketArticleId, productArticleId] );
            document.dispatchEvent( new CustomEvent( 'added_to_cart.acl', { detail: { params: Object.fromEntries( dataParams.entries() ) } } ) );

            await renderMiniBasket( dataParams );
            return response;
        })
        .catch( ( response ) => {
            if ( response && response.error ) {
                showErrorNotif( response.error[0].message, "__minibasket_err" )
            } else {
                console.error( response ); // eslint-disable-line no-console
            }

            return false;
        })
        .finally( () => {
            successIndicatorEls.forEach( buttonEl => buttonEl.classList.remove( 'en_button--loading' ) );
        })
}

function renderMiniBasket(dataParams){

    // No need to open cartreminder until tomorrow.
    EN.Cookies.set( 'closedcartreminder', 'true', { expires: 1, path: '/' });
    return AclMiniBasket.reload().then( () => {

        // after stuff
        triggerDetailPageMessages(dataParams);
    });
}

function triggerDetailPageMessages(dataParams = 0) {

    // item added
    dataParams = dataParams || 0;

    const addedToCartEl = document.querySelector( '.mdl_addedtocart' );
    const isQuickview = addedToCartEl && addedToCartEl.classList.contains( 'mdl_addedtocart--quickview' );

    if ( isQuickview ) {

    } else {

        // Disable page scroll for the container.
        if ( EN.Media.matches( null, 'desktop' ) ) {
            scrollLock.disablePageScroll( document.querySelector( '.mdl_addedtocart__container' ) );
        }
    }

    const containerEl = isQuickview ? addedToCartEl : document.getElementById( 'tobasketnotification' );
    containerEl.classList.add( 'is-active' );
    setTimeout(function () {
        containerEl.classList.add( 'is-visible' );
    }, 1);

    $('#tobasketerror').hide();

    if ($('#tobasketnotification').html() != undefined) {
        //click and reserve messages
        if(dataParams && dataParams.get( "type" ) === 'click_and_reserve'){
            $('.mdl_addedtocart__text').addClass('en_hidden');
            $('.mdl_addedtocart__text-clickandreserve').removeClass('en_hidden');
            $('.mdl_addedtocart__info').removeClass('en_hidden');
        } else {
            $('.mdl_addedtocart__text').removeClass('en_hidden');
            $('.mdl_addedtocart__text-clickandreserve').addClass('en_hidden');
            $('.mdl_addedtocart__info').addClass('en_hidden');
        }

        if ( isQuickview ) {
            document.querySelector( '#popup_article .mdl_popup__content' ).scroll( { top: 0, behavior: 'smooth'} );
        } else {
            window.scroll( { top: 0 , behavior: 'smooth'} );
        }
    }

    if (typeof econda_basket_add !== 'undefined' && $.isFunction(econda_basket_add)) {
        econda_basket_add();
    }
}
